// extracted by mini-css-extract-plugin
export var baseButton = "styles-module__base-button___UfdcI";
export var buttonGroup = "styles-module__buttonGroup___mQjsE";
export var destructivePrimary = "styles-module__destructive-primary___A3be7";
export var flat = "styles-module__flat___JvBF6";
export var primary = "styles-module__primary___QGD4z";
export var secondary = "styles-module__secondary___H4ckU";
export var secondaryGray = "styles-module__secondaryGray___POeOj";
export var small = "styles-module__small___tDdbT";
export var tertiary = "styles-module__tertiary___OSreE";